module.exports = __webpack_public_path__ + "media/images/riders/small/LOIC_BRUNI-6af08a83368510feb298338382564b2f.png";